module.exports = __webpack_public_path__ + "assets/img/JLD_Waterfront Promenade_RGB.da17cee6.jpg";